$(document).ready(function() {
	
	$('#menu-toggle').click(function() {

		const toggle = $(this);
		const text   = toggle.find('span');
		const nav    = $('nav');
		
		if (nav.css('display') == 'none') {
			toggle.css('background-color', 'var(--orange)');
			text.text('close');
			nav.css('display', 'flex');
		} else {
			toggle.css('background-color', 'var(--blue)');
			text.text('menu');
			nav.css('display', 'none');
		}
		
	});

	$('.list > .material-icons').click(function() {
		$(this).parent().toggleClass('show');
	});
	
	// hide extra fields for billing info in registration form middagformulier if the user has NOT marked the checkbox
	var selector = '#otherAddressCheckbox';
	if (!$(selector).is(":checked")) {
		$('.billingInfo').hide();
	}

	// hide/show extra fields for billing info in registration form middagformulier when the checkbox is used
	$(selector).change(function () {
		if ($(selector).is(":checked")) {
			$('.billingInfo').show();
		} else {
			$('.billingInfo').hide();
		}
	});

	// hide message for students in forms if the the respective radio button has not been selected
	if ($(":radio[value=Student]").length > 0 && !$(":radio[value=Student]").is(":checked")) {
		$('.messageStudent').hide();
	}
	// hide message for students dynamically according to user's input
	$('input[name="field[donateur]"]').change(function () {
		if ($(":radio[value=Student]").is(":checked")) {
			$('.messageStudent').show();
		} else {
			$('.messageStudent').hide();
		}
	});

});

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
